// extracted by mini-css-extract-plugin
export default {"container":"UiModal_container_m385J","light":"UiModal_light_KWTcS","dark":"UiModal_dark_Tn88g","closeButton":"UiModal_closeButton_zLqHv","openModal":"UiModal_openModal_PjW3D"};